module.exports = __webpack_public_path__ + "img/empleado-dentalia.ddccde7a.jpg";